import LogSneaky from "./logSneaky.js";
import Swiper from "https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.esm.browser.min.js";
// import Parallax from './parallax.js';

LogSneaky();

window.initialisation = () => {
  const popup = document.querySelector(".popup--overlay");
  const popupContent = document.querySelector(".popup--container");
  const tracabilite = document.querySelector(".tracabilite");
  const closeButton = document.querySelector(".popup--close");

  if (tracabilite) {
    tracabilite.addEventListener("click", (event) => {
      event.stopPropagation();
      event.preventDefault();
      popup.style.display = "block";
    });
  }

  if (closeButton) {
    closeButton.addEventListener("click", (event) => {
      event.preventDefault();
      popup.style.display = "none";
    });
  }

  if (popup) {
    popup.addEventListener("click", (event) => {
      event.preventDefault();
      popup.style.display = "none";
    });
  }

  if (popupContent) {
    popupContent.addEventListener("click", (e) => e.stopPropagation());
  }

  const btnPrevenezMoi = document.querySelector(
    "button.restock-alerts-notify-button.PRODUCT_PAGE-notify-button.notifyButtonStyle.product-form__submit.productSubmitButton-template--20332818235717__main.button.button--full-width.button--primary.btn.button.Button.button-primary.Button-primary.button--primary.Button--primary"
  );
  if (btnPrevenezMoi) {
    btnPrevenezMoi.disabled = false;
  }

  // const currentLangText = document.querySelector('.current-text');
  // const currentLang = document.querySelector('.current-lang');
  // const english = document.querySelector('#english');
  // const french = document.querySelector('#french');
  // const spanish = document.querySelector('#spanish');

  // // Determine the initial state based on the URL
  // if (/en-eu/.test(window.location.href)) {
  //     currentLangText.textContent = "English";
  //     english.style.display = "none";
  // } else if (/es-eu/.test(window.location.href)) {
  //     currentLangText.textContent = "Español";
  //     spanish.style.display = "none";
  // } else {
  //     currentLangText.textContent = "Français";
  //     french.style.display = "none";
  // }

  // // Toggle the open class to show/hide the dropdown smoothly
  // currentLang.addEventListener('click', () => {
  //     currentLang.classList.toggle('open');
  // });

  //captcha
  const body = document.querySelector("body");
  if (/challenge/.test(window.location.href)) {
    body.classList.add("captchaTemplate");
  }

  //Swiper
  const textSlide = document.querySelectorAll(".hero__sections .block__text");
  const paginationSlide = document.querySelectorAll(
    ".hero__sections .hero__swiper .swiper-pagination "
  );
  const swiperHome = new Swiper(".hero__swiper", {
    pagination: {
      clickable: true,
      el: ".swiper-pagination",
    }, // autoplay: true,
    speed: 900,
    on: {
      slideNextTransitionEnd: () => {
        const index_currentSlide = swiperHome.realIndex;
        const currentSlide = swiperHome.slides[index_currentSlide];
      },
    },
  });

  // swiperHome.on('slideChangeTransitionEnd', () => {
  //     for (let i = 0; i < subtitleSlide.length; i++) {
  //         subtitleSlide[i].classList.add('anim')
  //
  //         // subtitleSlide[i].classList.add('anim');
  //         // titleSlide[i].classList.add('anim');
  //         // paginationSlide[i].classList.add('anim');
  //     }
  // });

  //header open mega menu & change svg btn
  const shopHeaderBtn = document.querySelector(
    ".menu__header li:nth-of-type(1)"
  );
  const shopHeaderSvg = document.querySelector(".menu__header .shop__items ");
  const megaMenuHeader = document.querySelector(".megaMenu__nav");
  const megaMenuHeaderBorder = document.querySelector(".megamenu__header");
  const imagemegamenu = document.querySelector(".image__megamenu");
  const menuHeader = document.querySelector(".menu__header");
  const headerTopMobile = document.querySelector(".header__top--mobile ");

  shopHeaderBtn.addEventListener("click", (e) => {
    e.preventDefault();

    imagemegamenu.classList.toggle("active");
    megaMenuHeaderBorder.classList.toggle("active");
    shopHeaderSvg.classList.toggle("active");
    megaMenuHeader.classList.toggle("open");
    body.classList.toggle("overflowActive");

    if (megaMenuHeader.classList.contains("open")) {
      menuHeader.classList.add("borderAct");
    } else {
      menuHeader.classList.remove("borderAct");
    }
  });

  //mobile gesture
  let startY;

  headerTopMobile.addEventListener(
    "touchstart",
    (e) => {
      startY = e.touches[0].clientY;
    },
    false
  );

  headerTopMobile.addEventListener(
    "touchmove",
    (e) => {
      const touchY = e.touches[0].clientY;
      console.log(touchY);
      // Calculez la distance de glissement
      const distance = touchY - startY;

      // Si la distance est positive et dépasse un seuil, fermez le menu
      if (distance > 20) {
        // Le seuil peut être ajusté selon les besoins
        imagemegamenu.classList.remove("active");
        megaMenuHeaderBorder.classList.remove("active");
        shopHeaderSvg.classList.remove("active");
        megaMenuHeader.classList.remove("open");
        body.classList.remove("overflowActive");
      }
    },
    false
  );

  //header click outside

  document.addEventListener("click", (e) => {
    if (
      !megaMenuHeader.contains(e.target) &&
      !shopHeaderBtn.contains(e.target)
    ) {
      // headerTop.classList.remove("active")
      body.classList.remove("overflowActive");

      imagemegamenu.classList.remove("active");
      megaMenuHeaderBorder.classList.remove("active");
      shopHeaderSvg.classList.remove("active");
      megaMenuHeader.classList.remove("open");
    }
  });

  //recalc size vh
  window.addEventListener("resize", heightUnits);
  window.addEventListener("orientationchange", heightUnits);
  heightUnits();

  function heightUnits() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  }

  //check modbile / desktop

  // const footer = document.querySelector('.footer');
  // const mobileFooter = document.querySelector('.mobileFooter');
  // const desktopFooter = document.querySelector('.desktopFooter');

  // if (window.matchMedia('(max-width: 900px)').matches) {
  //     footer.classList.add('mobile');
  //     desktopFooter.classList.add('not-active');
  //     mobileFooter.classList.add('active');
  // } else {
  //     desktopFooter.classList.add('active');
  //     mobileFooter.classList.add('not-active');
  // }

  // Product page -- product info
  let TitleOptionAll = document.querySelectorAll(
    ".section__informations-product .items .title"
  );

  for (let i = 0; i < TitleOptionAll.length; i++) {
    let el = TitleOptionAll[i];

    el.addEventListener("click", (e) => {
      let allMenuLinks = document.querySelectorAll(
        ".section__informations-product .option .description"
      );

      if (allMenuLinks[i].className.match("show")) {
        allMenuLinks[i].classList.remove("show");
      } else {
        allMenuLinks[i].classList.add("show");
        TitleOptionAll[i].style.color = "black";
      }

      for (let j = 0; j < allMenuLinks.length; j++) {
        if (allMenuLinks[i] == allMenuLinks[j]) {
          continue;
        }
        allMenuLinks[j].classList.remove("show");
      }
    });
  }

  //megamenu deroulant

  const titleMegaManu = document.querySelectorAll(".megamenu__header .title");
  const childListSpec = document.querySelector(
    ".megamenu__header ul:nth-of-type(2)"
  );
  const titleSpec = document.querySelector(
    ".megamenu__header li:nth-of-type(1)"
  );

  if (window.matchMedia("(max-width: 900px)").matches) {
    titleMegaManu.forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault();
        el.classList.toggle("open");
        el.nextElementSibling.classList.toggle("open");
        console.dir(e.currentTarget);
        if (e.currentTarget === titleSpec) {
          childListSpec.classList.toggle("open");
        }
      });
    });
  }

  //filter

  const closeFilterModale = document.querySelector(".closeFilterModale");
  const filterBtn = document.querySelector(".collection-hero .filter__button");
  const filterModale = document.querySelector(".collection-hero .filterModale");
  const closeBtnModale = document.querySelector(".btnCloseModale");

  if (closeFilterModale) {
    closeFilterModale.addEventListener("click", (e) => {
      console.log(e.currentTarget);
      closeBtnModale.classList.remove("open");
      filterModale.classList.remove("open");
    });
  }

  if (filterBtn) {
    filterBtn.addEventListener("click", (e) => {
      filterModale.classList.add("open");
      closeBtnModale.classList.add("open");
      closeFilterModale.classList.toggle("open");
    });
  }

  if (closeBtnModale) {
    closeBtnModale.addEventListener("click", (e) => {
      closeBtnModale.classList.remove("open");
      filterModale.classList.remove("open");
    });
  }

  //togglerer main login
  // const loginTogglers = document.querySelectorAll('.section__login .login--toggler');
  // loginTogglers.forEach(el => {
  //     el.addEventListener('click', () => {
  //         document.querySelector('.section__login ').classList.toggle('recoveringNow');
  //     });
  // });
  //
  // console.log(location.hash);
  // if (location.hash == '#recover') {
  //     document.querySelector('section.login.customer').classList.add('recoveringNow');
  // }

  //header open search call
  const searchTwo = document.querySelector(".header__top--mobile");
  const details = document.querySelector(".header__search details");
  searchTwo.addEventListener("click", () => {
    details.setAttribute("open", true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  });

  //video lookbook

  let videoLook = document.querySelector(".lookbookVideoFull video");
  let ctaFullScreen = document.querySelector(".lookbookVideoFull .fullscreen");
  let ctaSound = document.querySelectorAll(".lookbookVideoFull .sound");
  let ctaSoundMuted = document.querySelector(".lookbookVideoFull .muted");
  let ctaSoundNotMuted = document.querySelector(".lookbookVideoFull .notmuted");

  if (ctaFullScreen) {
    ctaFullScreen.addEventListener("click", () => {
      openFullscreen();
    });
  }

  /* When the openFullscreen() function is executed, open the video in fullscreen.
      Note that we must include prefixes for different browsers, as they don't support the requestFullscreen method yet */
  function openFullscreen() {
    if (videoLook.requestFullscreen) {
      videoLook.requestFullscreen();
    } else if (videoLook.webkitRequestFullscreen) {
      /* Safari */
      videoLook.webkitRequestFullscreen();
    } else if (videoLook.msRequestFullscreen) {
      /* IE11 */
      videoLook.msRequestFullscreen();
    } else if (videoLook.webkitEnterFullscreen) {
      videoLook.webkitEnterFullscreen(); //for iphone this code worked
    }
  }

  ctaSound.forEach((el) => {
    el.addEventListener("click", () => {
      if (videoLook.muted) {
        videoLook.muted = false;
        ctaSoundNotMuted.style.display = "block";
        ctaSoundMuted.style.display = "none";
      } else {
        ctaSoundNotMuted.style.display = "none";
        ctaSoundMuted.style.display = "block";
        videoLook.muted = true;
      }
    });
  });
};
document.addEventListener("DOMContentLoaded", window.initialisation);
